import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { ProductOrder } from 'feature/productOrder/ProductOrder'
import { MainLayout } from 'layouts'

export function ServiceOrderPage() {
  return (
    <MainLayout>
      <ProductOrder orderType={orderFormSpace.FormType.service} />
    </MainLayout>
  )
}
